import { TIdToPageConfigMap } from 'models/common.model'
import { HeaderId } from 'nove8/constants/root-constants'
import { PageIdStylioArch61 } from './pages'

export const ID_TO_PAGE_CONFIG_MAP_STYLIO_ARCH_61: TIdToPageConfigMap = {
  [PageIdStylioArch61.SUBSCRIPTIONS_ARCH_61]: {
    id: PageIdStylioArch61.SUBSCRIPTIONS_ARCH_61,
  },
  [PageIdStylioArch61.SUB_UPSELL_ARCH_61]: {
    id: PageIdStylioArch61.SUB_UPSELL_ARCH_61,
    hasHeader: true,
    headerId: HeaderId.POLICY,
  },
  [PageIdStylioArch61.FACE_STYLING_PDF_UPSELL_ARCH_61]: {
    id: PageIdStylioArch61.FACE_STYLING_PDF_UPSELL_ARCH_61,
    hasHeader: true,
    headerId: HeaderId.POLICY,
  },
  [PageIdStylioArch61.PROPORTIONS_PDF_UPSELL_ARCH_61]: {
    id: PageIdStylioArch61.PROPORTIONS_PDF_UPSELL_ARCH_61,
    hasHeader: true,
    headerId: HeaderId.POLICY,
  },
  [PageIdStylioArch61.DOWNLOAD_ARCH_61]: {
    id: PageIdStylioArch61.DOWNLOAD_ARCH_61,
    hasHeader: true,
    headerId: HeaderId.POLICY,
  },
}
